<template>
  <div class="yxdw-wrap">
    <div class="yxdw-top">
      <div class="yxdw-top-right">
        <div v-if="doadd" :class="[{ yxdwchecked2: clickIndex2 == 0 }]" @click="operation(0)">创建</div>
        <div v-if="doupdate" :class="[{ yxdwchecked2: clickIndex2 == 1 }]" @click="operation(1)">修改</div>
        <div v-if="dodelete" :class="[{ yxdwchecked2: clickIndex2 == 2 }]" @click="operation(2)">状态</div>
      </div>
    </div>
    <div class="yxdw-container">
      <img src="../assets/image/lq-bg.png" alt />
      <div>
        <div class="yxdw-con-wrap">
          <div class="yxdw-con-title">
            <div>序号</div>
            <div>名称</div>
            <div>有效期</div>
            <div>地址</div>
            <div>销售员</div>
            <div>状态</div>
            <div>房价类型</div>
            <div>房价</div>
            <div>客户类型</div>
            <div class="ten">联系人</div>
            <div>备注</div>
          </div>
          <div class="yxdw-con-contaniner">
            <transition-group name="list">
              <div
                :class="['yxdw-con-item', { yxdwchecked: yxdwIndex == index }]"
                v-for="(item, index) in list"
                :key="'a'+index"
                @click="chooseYxdw(index)"
                @dblclick="dblItem(index)"
              >
                <div>{{ index + 1 }}</div>
                <div>{{ item.name }}</div>

                <div :title="item.begintime + '至' + item.endtime">{{ item.endtime }}</div>

                <div
                  :title="item.provincename + item.cityname + item.address"
                >{{ item.provincename }} {{ item.cityname }}</div>
                <div>{{ item.salesname }}</div>
                <div v-if="item.status == 0">正常</div>
                <div v-else-if="item.status == 1">禁用</div>
                <div v-else-if="item.status == 2">删除</div>
                <div v-else-if="item.status == 3">其他</div>
                <div v-if="item.ratetype == 1">协议价</div>
                <div v-else-if="item.ratetype == 2">房价码</div>
                <div v-else></div>
                <div v-if="item.ratetype == 1" :title="title" @mouseover="seeIt(index)">鼠标移入查看</div>
                <div v-else-if="item.ratetype == 2" :title="title" @mouseover="seeIt(index)">鼠标移入查看</div>
                <div v-else></div>
                <div>{{ item.typename }}</div>
                <div class="ten">{{ item.linkman }}/{{ item.linkphone }}</div>
                <div :title="item.remark">{{ item.remark }}</div>
              </div>
            </transition-group>
          </div>
        </div>
      </div>
    </div>

    <div class="confirm-wrap" v-if="visible">
      <div class="confirm-inner">
        <div class="confirm-header">
          <span>{{ title }}</span>
          <img src="../assets/image/close.png" alt @click="close" />
        </div>
        <div class="confirm-container">
          <div class="confirm-message">{{ message }}</div>
          <div class="confirm-message1">{{ message1 }}</div>
          <div class="confirm-button">
            <div @click="confirm">确定</div>
            <div @click="close">取消</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

 

<script>
import { getRequest, postRequest } from "@/api/api1.js";
export default {
  data() {
    return {
      list: [],
      dosee: false,
      doadd: false,
      doupdate: false,
      dodelete: false,
      title: "",
      visible: false,
      obj: {}
    };
  },
  computed: {
    yxdwIndex() {
      return this.$store.state.yingxiaodanweiIndex;
    },
    clickIndex2() {
      return this.$store.state.operationIndex4;
    }
  },
  created() {
    this.$store.state.yingxiaodakai = 1;
    this.$store.state.yingshoudakai = null;

    this.$store.state.yingxiaodanweiIndex = null;

    this.dosee = this.power.checkedpower("0302000");
    this.doadd = this.power.checkedpower("0302001");
    this.doupdate = this.power.checkedpower("0302002");
    this.dodelete = this.power.checkedpower("0302003");

    if (this.dosee == false) {
      this.$router.push("/power");
    }

    if (this.$store.state.tCustomerInfo.length > 0) {
      this.list = this.$store.state.tCustomerInfo;
    } else {
      let loadingInstance = this.$loading({
        text: "加载中"
      });
      getRequest(
        "/tCustomerInfo/selectAll?hotelId=" + localStorage.getItem("ihotelid")
      ).then(res => {
        
        this.$nextTick(() => {
          loadingInstance.close();
        });
        if (res.status == 200) {
          let result = res.data;
          // for (let i = 0; i < result.length; i++) {
          //   if (result[i].begintime) {
          //     result[i].begintime = result[i].begintime.split("T")[0];
          //   }
          //   if (result[i].endtime) {
          //     result[i].endtime = result[i].endtime.split("T")[0];
          //   }
          // }
          this.list = result;
          this.$store.state.tCustomerInfo = result;
        } else {
          this.$mymessage({
            content: res.message,
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      });
    }
  },

  methods: {
    operation(index) {
      
      if (index == 0) {
        this.$store.state.operationIndex4 = index;
        let obj = {
          operation: "创建"
        };
        this.$yxdw({ obj });
      } else if (index == 1) {
        if (this.$store.state.yingxiaodanweiIndex != null) {
          this.$store.state.operationIndex4 = index;
          let obj = JSON.parse(
            JSON.stringify(
              this.$store.state.tCustomerInfo[
                this.$store.state.yingxiaodanweiIndex
              ]
            )
          );
          obj.operation = "修改";
          obj.yingxiaodanweiIndex = this.$store.state.yingxiaodanweiIndex;
          this.$yxdw({ obj });
        } else {
          this.$mymessage({
            content: "请选择修改内容",
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      } else if (index == 2) {
        if (this.$store.state.yingxiaodanweiIndex != null) {
          this.$store.state.operationIndex4 = index;

          // let obj = JSON.parse(
          //   JSON.stringify(
          //     this.$store.state.tCustomerInfo[
          //       this.$store.state.yingxiaodanweiIndex
          //     ]
          //   )
          // );
          // obj.title = "删除";
          // obj.message = "您确定要删除吗";
          // obj.yingxiaodanweiIndex = this.$store.state.yingxiaodanweiIndex;

          // this.$confirm({ obj });
          let item = this.$store.state.tCustomerInfo[
            this.$store.state.yingxiaodanweiIndex
          ];
          
          // return;
          this.changestatus(item, index);
        } else {
          this.$mymessage({
            content: "请选择需要操作的数据",
            type: "error",
            time: 3000,
            hasClose: true
          });
        }
      }
    },
    changestatus(item, index) {
      let newitem = JSON.parse(JSON.stringify(item));
      this.title = "状态设置";
      if (newitem.status == 0) {
        this.message = "是否确认将 “" + item.name + "” 的状态设置为 “禁用”";
        this.message1 = "禁用后 将无法使用此应收单位进行结账";
        newitem.status = 1;
      } else {
        this.message = "是否确认将 “" + item.name + "” 的状态设置为 “启用”";
        this.message1 = "";
        newitem.status = 0;
      }
      this.obj.id = newitem.id;
      this.obj.status = newitem.status;
      this.index = index;
      this.visible = true;
    },
    close() {
      this.visible = false;
      this.obj = {};
      this.$store.state.operationIndex4 = null;
    },
    confirm() {
      let that = this;
      //this.obj.hotelid = parseInt(localStorage.getItem("ihotelid"));
      postRequest("/tCustomerInfo/updateTCustomerInfo", this.obj).then(res => {
        if (res.status == 200) {
          //创建 添加 删除按钮设置没选中
          this.$mymessage({
            content: "设置成功",
            type: "success",
            time: 2000,
            hasClose: true
          });
          that.$store.state.tCustomerInfo.splice(this.yxdwIndex, 1, res.data);
          that.visible = false;
          that.$store.state.operationIndex4 = null;
        } else {
          this.$mymessage({
            content: res.message,
            type: "error",
            time: 2000,
            hasClose: true
          });
        }
      });
    },
    chooseYxdw(index) {
      
      this.$store.state.yingxiaodanweiIndex = index;
      //console.log(444,index)
    },
    dblItem(index) {
      this.$store.state.yingxiaodanweiIndex = index;
      this.operation(1);
    },
    seeIt(index) {
      this.title = "";
      let obj = this.list[index];
      
      if (obj.ratetype == 1 && obj.id) {
        if (this.$store.state.tCustomerInfo[index].tCustagree) {
          this.title = this.$store.state.tCustomerInfo[index].tCustagree;
        } else {
          getRequest("/tCustagree/selectAll?customerId=" + obj.id).then(res => {
            
            if (res.status == 200) {
              

              let result = res.data;

              for (let i = 0; i < result.length; i++) {
                if (result[i].roomtypename) {
                  this.title += result[i].roomtypename + "---";
                }
                if (result[i].rate) {
                  this.title += "非周末:" + result[i].rate + "元---";
                }
                if (result[i].weekrate) {
                  this.title += "周末:" + result[i].weekrate + "元\n";
                }
                this.title += "-------------------------------------------\n";
              }
              // this.title = JSON.stringify(res.data);
              this.$store.state.tCustomerInfo[index].tCustagree = this.title;
              this.$store.state.tCustomerInfo[index].tCustagree2 = res.data;
            } else {
              this.titlt = "";
              this.$mymessage({
                content: res.message,
                type: "error",
                time: 3000,
                hasClose: true
              });
            }
          });
        }
      } else if (obj.ratetype == 2 && obj.ratetypeid != null) {
        if (this.$store.state.tCustomerInfo[index].tRoomRate) {
          this.title = this.$store.state.tCustomerInfo[index].tRoomRate;
        } else {
          
          getRequest(
            "/tRoomRate/selectRoomRates?rateTypeId=" + obj.ratetypeid
          ).then(res => {
            
            if (res.status == 200) {
              
              let result = res.data[0];
              if (result.ratename) {
                this.title += "房价码:" + result.ratename + "\n";
              }
              if (result.beginmothday) {
                this.title += "周期:" + result.beginmothday + "至";
              }
              if (result.begintime) {
                this.title +=
                  "周期:" +
                  result.begintime +
                  "\n-------------------------------------------\n";
              }
              if (result.endmothday) {
                this.title +=
                  result.endmothday +
                  "\n-------------------------------------------\n";
              }
              if (result.endtime) {
                this.title +=
                  result.endtime +
                  "\n---------------------------------------------\n";
              }
              this.title += "-------------------------------------------\n";
              for (let i = 0; i < result.rateList.length; i++) {
                if (result.rateList[i].roomtypename) {
                  this.title += result.rateList[i].roomtypename + "---";
                }
                if (result.rateList[i].rate) {
                  this.title += "非周末:" + result.rateList[i].rate + "元---";
                }
                if (result.rateList[i].weekrate) {
                  this.title += "周末:" + result.rateList[i].weekrate + "元\n";
                }
                this.title += "-------------------------------------------\n";
              }
              // this.title = JSON.stringify(res.data);
              this.$store.state.tCustomerInfo[index].tRoomRate = this.title;
            } else {
              this.title = "";
              this.$mymessage({
                content: res.message,
                type: "error",
                time: 3000,
                hasClose: true
              });
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.yxdw-wrap {
  width: 102%;
  height: 100%;
  z-index: 99;
  margin-left: -1%;
  position: relative;
  overflow: hidden;
}
.yxdw-top {
  width: 100%;
  height: 7%;
  padding: 0 3%;
  /* background: red; */
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 2%;
}

.yxdw-top-right div {
  width: 30%;
  height: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
}

.yxdwchecked2 {
  background: url(../assets/image/lq-bg2.png);
  color: #fb7a01;
  background-size: 100% 100%;
  font-weight: bolder;
}
.yxdw-top-right {
  width: 20%;
  height: 90%;
  box-shadow: 8px 8px 20px #b9ccec, -8px -8px 15px #ffffff;
  border-radius: 7px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 0.8em;
  color: #575f6b;
  padding: 0 1%;
}
.yxdw-container {
  width: 100%;
  height: 93%;
  margin: 0 0 0;
  position: absolute;
  top: 8.5%;
}
.yxdw-container img {
  width: 100%;
  height: 100%;
  position: absolute;
}
.yxdw-container > div {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  padding: 2% 3%;
  overflow: hidden;
}
.yxdw-con-wrap {
  width: 100%;
  height: 100%;
  padding: 1%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.yxdw-con-title {
  width: 100%;
  display: flex;
  flex-shrink: 0;
}
.yxdw-con-title div {
  text-align: center;
  color: #2c3036;
  font-size: 0.8em;
  line-height: 3.2em;
  width: 7.5%;
}
.yxdw-con-title div:nth-child(2) {
  width: 15%;
}
.yxdw-con-item div:nth-child(2) {
  width: 15%;
}
.yxdw-con-title div:nth-child(4) {
  width: 15%;
}
.yxdw-con-title .ten {
  width: 15%;
}
.yxdw-con-contaniner {
  color: #6d798e;
  font-size: 14px;
  flex: 1;
  overflow: auto;
  white-space: nowrap;
}
.yxdw-con-item {
  display: flex;
  width: 100%;
  border: 1px solid transparent;
  cursor: pointer;
}
.yxdw-con-item div {
  text-align: center;
  line-height: 3em;
  width: 7.5%;
  overflow: hidden;
}
.yxdw-con-item div:nth-child(4) {
  width: 15%;
}
.yxdw-con-item .ten {
  width: 15%;
}
.yxdw-con-contaniner.yxdw-con-contaniner .yxdwchecked {
  box-shadow: 3px 3px 4px #a0bdee inset, -3px -3px 4px white inset;
  border: 1px solid #1471fe;
  border-radius: 10px;
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter
/* .list-leave-active for below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(100%);
}
.list-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
.confirm-wrap {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  position: fixed;
}
.confirm-wrap::after {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgb(161, 160, 160);
  opacity: 0.4;
  content: "";
  z-index: -1;
}
.confirm-inner {
  width: 500px;
  border-radius: 10px;
  overflow: hidden;
  background: #e8f0ff;
}
.confirm-header {
  width: 100%;
  height: 50px;
  padding: 0 8px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  color: #2c3036;
}
.confirm-header img:hover {
  transform: scale(1.2);
  cursor: pointer;
}
.confirm-container {
  box-shadow: 0px 2px 4px #b9ccec inset;
  padding: 20px;
}
.confirm-message {
  height: 55px;
  font-size: 16px;
  color: #2c3036;
  margin-left: 20px;
}
.confirm-message1 {
  height: 40px;
  font-size: 12px;
  color: red;
  margin-left: 20px;
}

.confirm-button {
  width: 100%;
  font-size: 10px;
  color: #575f6b;
  display: flex;
  justify-content: center;
}
.confirm-button div:nth-child(1) {
  margin-right: 20px;
}

.confirm-button div {
  width: 120px;
  height: 30px;
  box-shadow: 4px 0px 10px #b9ccec, -4px -4px 10px #ffffff;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1471fe;
  color: white;
  cursor: pointer;
}
.confirm-enter-active,
.confirm-leave-active {
  transition: all 1s;
}
.confirm-enter {
  opacity: 0;
}
.confirm-leave-to {
  opacity: 0;
}
</style>